import * as uuid from 'uuid';

import type { NoraWebViewMapSource } from '@nora-monorepo/ui-shared';

import { MapSetup } from '#nora-ui/map/map/MapSetup';
import { useMapStore } from '#nora-ui/map/stores/map-store';

export function simulateOfflineMap(url: string, name?: string) {
  const mapSetup = MapSetup.getInstance();
  const mapStore = useMapStore();

  const mapName = name ?? url.split('/').pop() ?? 'New Offline Map';

  const mapSource: NoraWebViewMapSource = {
    id: uuid.v4(),
    name: mapName,
    mapSource: url,
  };

  // Add the offline map to the global map setup so new maps can use it
  mapSetup.addOfflineMap(mapSource);
  // eslint-disable-next-line no-console
  console.log(`[Simulate] Added offline map '${mapName}' to global setup.`);

  // Add the offline map to all existing map instances
  mapStore.mapInstances.forEach((mapInstance) => {
    const map = mapStore.getMapById(mapInstance.id);

    if (map) {
      map.layers.addOfflineMap(mapSource);
      // eslint-disable-next-line no-console
      console.log(`[Simulate] Added offline map '${mapName}' to map instance ${mapInstance.id}.`);
    }
  });
}
